import { TipsMapType } from '..';

export const hashtagTotalPotentialImpressionTips: TipsMapType = {
  en: "The total number of times users viewed posts under this hashtag (including duplicate views).",
  zh: '用户浏览本Hashtag下帖子的次数（不去重）',
};